/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forgot_Password_LinkInputs */

const en_mobile_forgot_password_link = /** @type {(inputs: Mobile_Forgot_Password_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I forgot my password`)
};

const es_mobile_forgot_password_link = /** @type {(inputs: Mobile_Forgot_Password_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olvidé mi contraseña`)
};

/**
* | output |
* | --- |
* | "I forgot my password" |
*
* @param {Mobile_Forgot_Password_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forgot_password_link = /** @type {((inputs?: Mobile_Forgot_Password_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forgot_Password_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forgot_password_link(inputs)
	return en_mobile_forgot_password_link(inputs)
});